<template>
<div id="ServiceCodePrereqServiceCodesAddEdit">

<form>
  
  <div class="form-group row my-1">
    <label for="tooth" class="col-sm-4 label-small my-0">Specs Ben:</label>
    <div class="col-sm-4 my-0">
      <input id="tooth"   maxlength="4" v-model="prerequisite" placeholder="Prerequisite" class="mb-0 form-control form-control-xs" @input="prerequisite = $event.target.value.toUpperCase()">
    </div>
  </div>

  <div class="form-group row" v-show="$v.prerequisite.$error" > 
    <small class="sml-red ml-3" v-if="!$v.prerequisite.required">Specs Ben is required</small>
    <small class="sml-red ml-3" v-if="!$v.prerequisite.SAILCode && $v.prerequisite.required">Specs Ben must start SB and be followed by 2 numbers</small>
    <small class="sml-red ml-3" v-if="!$v.prerequisite.Duplicate && $v.prerequisite.required">Specs Ben already added</small>
  </div>

  <div class="form-group row my-1">
    <label for="tooth" class="col-sm-4 label-small my-0">Percentage:</label>
    <div class="col-sm-4 my-0">
      <input id="tooth"   maxlength="5" v-model="pctDPPays" placeholder="Prerequisite" class="mb-0 form-control form-control-xs">
    </div>
  </div>
  
  <div class="form-group row" v-show="$v.pctDPPays.$error" > 
    <small class="sml-red ml-3" v-if="!$v.pctDPPays.required">Percentage is required</small>
    <small class="sml-red ml-3" v-if="!$v.pctDPPays.OnevThree && $v.pctDPPays.required">Percentage can have up to 3 decimals and maximum value of 9.999</small>
  </div>
     
<hr>
<div class="row" >
    <div class="col-sm-6" >
            <button v-on:click="SavePopup" :disabled="disableSave" type="button" class="btn btn-info  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
    </div>
    <div class="col-sm-6">
        <button v-on:click="ClosePopup" type="button" class="btn btn-warning btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
    </div>
</div>

</form>
</div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'

Vue.use(Vuelidate)
import { required, minLength, maxLength, between,withParams,email,numeric} from 'vuelidate/lib/validators'
import { notEqual } from 'assert'; 
const SAILCode = helpers.regex('alphnum',/^[sS][bB]\d{2}$/)
const OnevThree = helpers.regex('alphnum',/^1{1}(\.[0]{1,3})?$|^0{0,1}(\.[0-9]{1,3})?$/)
export default {
    props:{
        UserData:'',
        mode:'',
        DataSet:'',
        UserRow:'',

    },
  data: function(){
    return{
        saveIcon:'fas fa-plus',
        btnName: 'Add SAIL Benefits',
        succeeded:true,
        showModal:false,
        showModal:false,
        Msg:'',
        EditMode:'',
        disableSave:false,
        prerequisite:'',
        pctDPPays:'',
        updateRow:{
          prerequisite:'',
          pctDPPays:'',
        },
        tabledata:'',
        editedRow:''
    }   
  },

  created: function(){
    this.EditMode = this.mode;

    if(this.EditMode  == 'Edit')
    {
        this.btnName = 'Edit SAIL Benefits';
        this.saveIcon = 'far fa-edit'; 
    } 
    this.prerequisite = this.UserData.prerequisite;
    this.pctDPPays = this.UserData.pctDPPays;
    this.tabledata = this.DataSet;
    this.editedRow = this.UserRow
  },
methods: {
  ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'ServiceCodeSAILAddEdit', '#btnShow') 
         //this.$v.$reset();
    },
    SavePopup: function(){
       this.$v.$touch();

      if (!this.$v.$invalid){
          this.updateRow.prerequisite = this.prerequisite;
          this.updateRow.pctDPPays = this.pctDPPays;
          this.$emit('ServiceCodeSAILUpdate', this.updateRow)
          this.showModal=false;
      }
    },
},
  validations(){
    return {
        prerequisite:{
            required,
            SAILCode,
            Duplicate: value=> this.tabledata.findIndex(x=>x.prerequisite == this.prerequisite)== -1 || this.tabledata.findIndex(x=>x.prerequisite == this.prerequisite) == this.editedRow
        },
        pctDPPays:{
          required,
          OnevThree
        }
    }
  }
}
</script>

<style>

</style>
